import "./IconBookmark.scss";
import { ReactComponent as BookmarkFilledIcon } from "./svg/bookmarkFilled.svg";

interface Props {
  className?: string;
}

export const IconBookmarkFilled = ({ className = "" }: Props) => {
  return (
    <span className={`IconBookmark ${className}`}>
      <BookmarkFilledIcon />
    </span>
  );
};
